import React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { Headings } from "@arctheme-components/elements/Headings/Headings";

const ContentArea = ({ settings, description, isMobile }) => {
    let heading = settings.title;
    
    // Determine text spacing
    const textGap = isMobile ? settings.text_gap_mobile || 24 : settings.text_gap || 24;
    
    return (
        <div className={`flex flex-col gap-[${textGap}px] max-w-[800px]`}>
            {settings.tagline && (
                <Paragraph 
                    text={settings.tagline} 
                    type={isMobile ? settings.tagline_style_mobile || "b_small_light" : settings.tagline_style || "b_small_light"} 
                    maxChars={9999}
                />
            )}
            {heading && (
                <Headings
                    text={heading}
                    type={
                        isMobile
                            ? settings.heading_type_mobile
                            : settings.heading_type
                    }
                />
            )}
            <div className={`flex flex-col space-y-[24px]`}>
                {settings.subheading && (
                    <Paragraph
                        text={settings.subheading}
                        type={`${isMobile ? settings.subheading_style_mobile : settings.subheading_style}`}
                        maxChars={9999}
                    />
                )}
                {description && (
                    <Paragraph
                        text={description}
                        type={`${isMobile ? settings.content_style_mobile : settings.content_style}`}
                        maxChars={9999}
                    />
                )}
            </div>
        </div>
    );
};

export default ContentArea;
